module.exports = __webpack_public_path__ + "static/media/view6.98a6be1b.jpg";